<div
  [contextMenuTrigger]="menu"
  *ngIf="hasPermission"
  [menuContext]="{ value: costSpentformsetting, visible: formVisible }"
  (menuAction)="($event)"
  class="form-parent">
  <kgrid
    [apiName]="apiName"
    [label]="label"
    [areaName]="areaName"
    [name]="apiName"
    reportName="CostSpent"
    defaultSortKey="CostSpntDate"
    defaultSortKeyKind="des"
    pathPreFix="SALE"
    [IgnoreDeletePermission]="IgnoreDelete"
    [deleteMessage]="deleteMessage"
    [inputEditorform]="inputEditorform"
    [isAdd]="isAdd"
    [isEdit]="isEdit"
    [isDelete]="isDelete"
    [unSortableFilterable]="unSortableFilterable"
    [filters]="filters">
  </kgrid>
</div>
